import { Container as BaseContainer } from 'react-bootstrap';
import styled from 'styled-components';
import { defaultShadow } from '../../styles/global';

export const Container = styled(BaseContainer)`
  background: ${(p) => p.theme.colors.surface};

  width: 100%;
  padding: 0;

  ${defaultShadow}

  @media(min-width: 1920px) {
    max-width: 1920px;
  }

  @media(max-width: 520px) {
    margin-bottom: 6rem;
  }
`;

export const HeaderBar = styled.div`
  background: ${(p) => p.theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0.5rem 1rem;
  height: 3.5rem;
  gap: 0.75rem;

  /* Efeito de brilho sutil no topo */
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
  }

  .content-container-title {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: ${(p) => p.theme.colors.onPrimary};
    cursor: pointer;
    transition: opacity 0.2s ease;
    flex-shrink: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

    &:hover {
      opacity: 0.9;
    }
  }

  .content-container-title-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .content-container-title-addon {
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
  }

  .content-container-actions-area {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    gap: 0.5rem;
    flex-shrink: 0;

    list-style: none;

    li {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.25rem;
      border-radius: 0.375rem;
      transition: background-color 0.2s ease;
      cursor: pointer;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
      }

      svg {
        transition: transform 0.2s ease;
      }

      &:hover svg {
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 768px) {
    padding: 0.5rem 0.75rem;

    .content-container-title {
      font-size: 1.3rem;
    }
  }
`;

export const Content = styled.div`
  padding: 0.75rem 1.25rem;

  @media (max-width: 768px) {
    padding: 0;
  }
`;
